import React, { useState, useEffect, Suspense, lazy } from "react";
import Carousel from "react-spring-3d-carousel-2";
import { config } from "react-spring";
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";
import "./carousel.css";

export default function Foxvideosection() {

  let slides = [];
  const arrowimg = process.env.REACT_APP_POSTAMAZINGMORGAN_CDN_URL;
  const [BannerPics, setBannerPics] = useState([]);
  const audio = new Audio();
  audio.src = process.env.REACT_APP_CLICK_SOUND;

  const [state, setState] = useState({
    goToSlide: 0,
    offsetRadius: 4,
    showNavigation: false,
    config: config.gentle,
    draggable: true,
  });

  let xDown = null;
  let yDown = null;

  const getTouches = (evt) => {
    return (
      evt.touches || evt.originalEvent.touches // browser API
    ); // jQuery
  };

  const handleTouchStart = (evt) => {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
   
  };

  const handleTouchMove = (evt) => {
    if (!xDown || !yDown) {
      return;
    }

    let xUp = evt.touches[0].clientX;
    let yUp = evt.touches[0].clientY;

    let xDiff = xDown - xUp;
    let yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /*most significant*/
      if (xDiff > 0) {
        /* left swipe */
        setState({ goToSlide: state.goToSlide + 1, offsetRadius: 4 });
        audio.play();
      } else {
        /* right swipe */
        setState({ goToSlide: state.goToSlide - 1, offsetRadius: 4 });
        audio.play();
      }
    } else {
      if (yDiff > 0) {
        /* up swipe */
      } else {
        /* down swipe */
      }
    }
   
    /* reset values */
    xDown = null;
    yDown = null;
  };

  useEffect(() => {
    // Get the event pics from a JSON file hosted in the cdn
    async function fetchBannerPics() {
      try {
        const memoryPics = await axios.get(process.env.REACT_APP_LOGOCAROUSEL);
        // console.log(memoryPics.data);
        let memoryPicsData = memoryPics.data.carousel;
        for (var data of memoryPicsData) {
          slides.push({
            key: data.thumbnail,
            content: (
              <a href={data.url} target="_blank">
                <img src={data.imgPath} className="postimages1" />
              </a>
            ),
          });
        }
        // console.log("slides: " + JSON.stringify(slides));
        let BannerPicsData = slides.map((slide, index) => {
          return {
            ...slide,
            onClick: () => setState({ goToSlide: index, offsetRadius: 4 }),
          };
        });
        setBannerPics(BannerPicsData);
      } catch (err) {
        console.log(err);
      }
    }
    fetchBannerPics();
  }, []);

  return (
    <>
      <div >
        <Container>
          <Row>
            <Col sm={12}>
              <div
                className="posts2"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
              >
                <Carousel
                  slides={BannerPics}
                  autoPlay
                  draggable={state.draggable}
                  goToSlide={state.goToSlide}
                  offsetRadius={state.offsetRadius}
                  showNavigation={state.showNavigation}
                  animationConfig={state.config}
                  goToSlideDelay="20000"
                  interval={20}
                />
              </div>
              <div>
                <img
                  src={arrowimg + "LA.png"}
                  className="leftArrow"
                  alt="leftnavigation"
                  onClick={() => {
                    setState({
                      goToSlide: state.goToSlide - 1,
                      offsetRadius: 4,
                    });
                    audio.play();
                  }}
                />

                <img
                  src={arrowimg + "RA.png"}
                  className="rightArrow"
                  alt="rightnavigation"
                  onClick={() => {
                    setState({
                      goToSlide: state.goToSlide + 1,
                      offsetRadius: 4,
                    });
                    audio.play();
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
